import React from "react";
import "./Sections.scss";

function Section4() {
  return (
    <section className="sections sections-section4">
      <p className="sections-title">Lowering the purchase threshold</p>
      <p className="sections-copy">
        One of the biggest misconceptions in real estate is the idea that buyers
        need to pull together a down payment equal to 20% or even 10% of the
        purchase price in order to buy a home. In fact, the typical down payment
        is in the single digits – usually around 6% or 7% for a first-time home
        buyer. And{" "}
        <a
          className="hyperLink"
          href="https://www.nar.realtor/first-time-homebuyers/first-time-homebuyer-loans-grants"
          target="_blank"
          rel="noreferrer"
        >
          some people may even qualify for lower down payments
        </a>{" "}
        of 3.5% or less if they served in the military, work in public service,
        live in certain communities, or meet low-income qualifications.
        “Programs like these bring the benefits of home ownership within reach
        of a broader group of buyers,” says Lautz.
      </p>
    </section>
  );
}

export default Section4;
